import { render } from "./OptionsDivider.vue?vue&type=template&id=704109cf"
import script from "./OptionsDivider.vue?vue&type=script&lang=js"
export * from "./OptionsDivider.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__